import { procurementAPI } from "../../axios";

export const actions = {

    //ItemPackage
    GetItemPackage(context, data){
        return procurementAPI.get(`ItemPackage/All`);
    },
    GetSingleItemPackage(context, data){
        return procurementAPI.get(`ItemPackage/${data}`);
    },
    UpdateItemPackage(context, data){
        return procurementAPI.put(`ItemPackage/${data.id}`, data);
    },
    DeleteItemPackage(context, data){
        return procurementAPI.delete(`ItemPackage/${data}`);
    },
    CreateItemPackage(context, data){
        return procurementAPI.post(`ItemPackage/CreateItemPackage`, data);
    },

}